export class PreloadController {
    constructor() {
        this._preloader = document.querySelector('.preloader');
        this._header = document.querySelector('.header');
        this._preloaderLeft = this._preloader.querySelector('.column__left');
        this._preloaderRight = this._preloader.querySelector('.column__right');
    }

    start() {
        this._preloader.classList.add('show');
        this._header.classList.add('show');
    }
}
